module.exports = __webpack_public_path__ + "img/shop-style-filter-nissan.c75799e7.png";